import React from 'react'
import { toast } from 'react-toastify'

import ToastNotificationStatus from './components/ToastNotificationStatus'

const defaultToastConfig = {
  position: 'bottom-left',
  className: 'save-toast-notification',
  pauseOnFocusLoss: false,
  closeOnClick: true,
  pauseOnHover: true,
  closeButton: false,
  hideProgressBar: true,
}

/**
 * Ok save
 * @param {object} params
 * @param {string} [params.text]
 * @param {boolean} [params.disableInternationalization]
 * @param {string} [params.className]
 */
const ok = (params = {}) => {
  const { text, disableInternationalization, className } = params

  toast(
    <ToastNotificationStatus
      type='ok'
      text={text || 'dashboard_changes-saved-successfully'}
      disableInternationalization={!!disableInternationalization}
      className={className || ''}
    />, {
      ...defaultToastConfig,
      autoClose: 2000,
    }
  )
}

/**
 * Error save
 * @param {object} params
 * @param {string} [params.text]
 * @param {boolean} [params.disableInternationalization]
 * @param {string} [params.className]
 */
const error = (params = {}) => {
  const { text, disableInternationalization, className } = params

  toast(
    <ToastNotificationStatus
      type='error'
      text={text || 'dashboard_error-saving-changes'}
      disableInternationalization={!!disableInternationalization}
      className={className || ''}
    />, {
      ...defaultToastConfig,
      autoClose: 4000,
    }
  )
}

export default { ok, error }
